import dayjs from 'dayjs';
import { STRINGS } from '../../Constants/ConstantStrings';
import { RootState } from '../../store';
import { useReduxSelector } from '../../Store/reduxHooks';
import { ArcadisIcon } from '../../Universal/Assets';
import { Footer } from './styles';

export default function FooterComponent() {
  const clientName = useReduxSelector(
    (state: RootState) => state.ClientInfo.client_name
  );

  return (
    <Footer>
      <div className="d-flex left overflow-auto">
        <div className="d-flex product-ad">
          <p>{clientName} is a product of</p>
          <img
            src={ArcadisIcon}
            alt="arcadis-icon"
            className="pe-2 ps-2"
            loading="lazy"
          />
        </div>
        <p>© {dayjs().year()} All Rights Reserved</p>
      </div>
      <p className="right">
        {STRINGS.FOR_MORE_DETAILS_VISIT} :{' '}
        <a
          href="https://traveliq.co/"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="For more details visit www.traveliq.co"
        >
          <span className="link-text">&nbsp;www.traveliq.co</span>
        </a>
      </p>
    </Footer>
  );
}
